import BaseApi from "./baseApi";

class WaitListCoupleApi extends BaseApi {


  async waitListCouplesData(data: Record<string, unknown> | object): Promise<any> {
    return await this.API({
      url: "/waitList//wait-list-couples-data",
      data: data,
      method: "post",
    });
  }
}

export default WaitListCoupleApi;
